/*
 * All You Can Play - pulsante "Mostra di più" delle collezioni (sections/main-collection-product-grid.liquid).
 *
 * La sezione mette nella pagina tutti i prodotti della collezione (fino a 250, il limite di Shopify):
 * con l'ordine normale prima i disponibili e poi gli esauriti. Si vedono "Prodotti per pagina" alla volta
 * e il pulsante ne mostra altrettanti ogni volta, senza ricaricare la pagina.
 * Se i prodotti sono più di 250 (oggi solo "Tutti i prodotti"), le pagine successive si caricano in sottofondo
 * e si aggiungono: con l'ordine normale i disponibili vanno prima del primo esaurito, gli esauriti in fondo.
 * Funziona anche dopo filtri e ordinamento, che ridisegnano la griglia senza ricaricare la pagina.
 * I prodotti esclusi dalla colonna dei filtri (classe aycp-off, assets/collection-filters.js) non contano.
 */
(function () {
  function grid(container) {
    return container.querySelector('#product-grid');
  }

  function items(container) {
    var list = grid(container);
    if (!list) return [];
    return Array.prototype.slice.call(list.children).filter(function (item) {
      return !item.classList.contains('aycp-off');
    });
  }

  function refresh(container) {
    var wrapper = container.querySelector('.aycp-show-more');
    if (!wrapper) return;
    var hidden = items(container).filter(function (item) {
      return item.hidden;
    });
    wrapper.hidden = hidden.length === 0 && container.dataset.aycpLoading !== 'true';
  }

  function showMore(container) {
    var step = parseInt(container.dataset.aycpStep, 10) || 16;
    var shown = 0;
    items(container).forEach(function (item) {
      if (item.hidden && shown < step) {
        item.hidden = false;
        shown += 1;
      }
    });
    refresh(container);
  }

  // Dopo aver aggiunto prodotti, si vedono di nuovo i primi tanti quanti se ne vedevano prima.
  function keepVisible(container, visible) {
    items(container).forEach(function (item, index) {
      item.hidden = index >= visible;
    });
  }

  function loadRest(container) {
    var pages = parseInt(container.dataset.aycpPages, 10) || 1;
    var list = grid(container);
    if (pages < 2 || !list) return;

    container.dataset.aycpLoading = 'true';
    var split = container.dataset.aycpSplit === 'true';
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.set('section_id', list.dataset.id);

    var requests = [];
    for (var page = 2; page <= pages; page++) {
      var query = new URLSearchParams(params);
      query.set('page', page);
      requests.push(
        fetch(window.location.pathname + '?' + query.toString()).then(function (response) {
          return response.text();
        })
      );
    }

    Promise.all(requests)
      .then(function (pagesHtml) {
        if (!container.isConnected) return;
        var visible = items(container).filter(function (item) {
          return !item.hidden;
        }).length;
        var firstSoldOut = split ? list.querySelector(':scope > li[data-aycp-available="false"]') : null;

        pagesHtml.forEach(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('#product-grid > li').forEach(function (source) {
            var item = document.importNode(source, true);
            // Niente animazione di entrata: i prodotti aggiunti dopo compaiono subito quando si mostrano.
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            item.removeAttribute('data-cascade');
            item.style.removeProperty('--animation-order');
            if (split && firstSoldOut && item.dataset.aycpAvailable === 'true') {
              list.insertBefore(item, firstSoldOut);
            } else {
              list.appendChild(item);
            }
          });
        });

        keepVisible(container, visible);
      })
      .catch(function () {
        /* se le pagine successive non si scaricano, restano i primi 250 prodotti */
      })
      .then(function () {
        container.dataset.aycpLoading = 'false';
        refresh(container);
      });
  }

  function setup() {
    document.querySelectorAll('[data-aycp-collection]').forEach(function (container) {
      if (container.dataset.aycpReady === 'true') return;
      container.dataset.aycpReady = 'true';
      loadRest(container);
      refresh(container);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-aycp-show-more]');
    if (!button) return;
    var container = button.closest('[data-aycp-collection]');
    if (container) showMore(container);
  });

  function start() {
    setup();
    // Filtri e ordinamento sostituiscono il contenuto di #ProductGridContainer: si riparte con la griglia nuova.
    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) new MutationObserver(setup).observe(gridContainer, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
